import React, { useEffect, useState } from "react";
import Header from "../../layout/header/header";
import Footer from "../../layout/footer/footer";

import blogImg from "../../assets/blogimg.png";
import img222 from "../../assets/img222.png";
import "../blogs/blogs.css";
import BlogCardSm from "./BlogCardSm";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Blogs = () => {
  const history = useHistory();
  const [blogsData, setBlogsData] = useState([]);
  const [firstBlog, setFirstBlog] = useState(null);

  useEffect(() => {
    fetchAllBlogs();
  }, []);

  const fetchAllBlogs = async () => {
    const querySnapshot = await getDocs(collection(db, "blogs"));
    let mBlogs = [];
    querySnapshot.forEach((doc, index) => {
      mBlogs.push({ ...doc.data(), id: doc.id });
    });
    setFirstBlog(mBlogs[0]);
    mBlogs.splice(0, 1);
    console.log("BLOGS: ", mBlogs);
    setBlogsData(mBlogs);
  };

  useEffect(() => {
    // if (Object.keys(firstBlog).length) {
    console.log("FIRST BLOG: ", firstBlog);
    // }
  }, [firstBlog]);

  const formatAMPM = (date) => {
    var day = date.getDate();
    var month = date.getMonth();
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = `${day}/${month}/${year} ${hours} : ${minutes} ${ampm}`;
    return strTime;
  };

  return (
    <div>
      <Header />
      {/* <!-- blog banner start --> */}
      <section className="blog_main">
        <div className="container-fluid">
          <h2 className="text-center heading_dgn">Blogs</h2>
          {firstBlog ? (
            <div
              className="row align-items-center"
              onClick={() =>
                history.push({
                  pathname: `/blogs/${firstBlog.id}`,
                  state: { blogData: firstBlog },
                })
              }
            >
              <div className="col-lg-7">
                <div className="blogs_inner">
                  <img
                    className="img-fluid"
                    src={firstBlog?.image || blogImg}
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "fit-content",
                    }}
                    alt="img"
                  />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="blog_content">
                  <div className="con_top">
                    <h3>{firstBlog.title}</h3>
                  </div>
                  <p>{firstBlog?.content.substring(0, 379) + "..."}</p>
                  <div className="con_botm d-flex justify-content-between">
                    {/* <div>
                    <i className="fa fa-repeat" aria-hidden="true"></i>
                    <i className="fa fa-cloud-download" aria-hidden="true"></i>
                  </div> */}
                    <div>
                      <span>
                        {formatAMPM(new Date(parseInt(firstBlog.date)))}{" "}
                      </span>{" "}
                      {/* <span>2 K Views</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            "Loading"
          )}
        </div>
      </section>
      {/* <!-- blog banner end -->

    <!-- repairing and servicing --> */}
      <section className="repairing_and_servicing">
        <div className="container-fluid">
          {/* <h3>AC Repairing and servicing</h3> */}
          <div className="row">
            {blogsData.length
              ? blogsData.map((blogObj, index) => (
                  <BlogCardSm blogObj={blogObj} key={index} />
                ))
              : "No blogs found!"}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Blogs;
